var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container mt-2" }, [
      _c("div", { staticClass: "error" }, [
        _c("div", { staticClass: "dice" }, [_vm._v("----")]),
        _vm._v(" "),
        _c("h2", [
          _vm._v("There was an error. Would you like to "),
          _c("a", { attrs: { href: "/" } }, [_vm._v("succeed at a cost?")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }